import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';


export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isCurrentTokenValid()) {
    console.log(' Token inválido - Redirigiendo al login');
    authService.clearAuth();
    router.navigate(['/authentication/login'], {
      queryParams: { returnUrl: state.url }
    });
    return false;
  }
  console.log(' Acceso permitido');
  return true;
};


/* Guard para verificar roles específicos */
export const roleGuard = (allowedRoles: string[]): CanActivateFn => {
  return (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (!authService.isCurrentTokenValid()) {
      authService.clearAuth();
      router.navigate(['/authentication/login'], {
        queryParams: { returnUrl: state.url }
      });
      return false;
    }

    // Verificar rol
    if (!authService.hasAnyRole(allowedRoles)) {
      console.warn(` Rol no permitido. Requeridos: ${allowedRoles.join(', ')}`);
      router.navigateByUrl(authService.getDefaultLandingUrl());
      return false;
    }

    return true;
  };
};
